import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';

const FilterGroupPanel = ({dataQe, title, ...props}) => {
  return (
    <Accordion defaultExpanded elevation={0} data-qe={dataQe} {...props}>
      <AccordionSummary expandIcon={<ExpandMoreIcon color="grey" />}>
        <Typography variant="overline">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          paddingY: 0,
        }}
      >
        {props.children}
      </AccordionDetails>
    </Accordion>
  );
};

FilterGroupPanel.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  dataQe: PropTypes.string,
};

export default FilterGroupPanel;
